/**
 * 검색 0건 화면 "이런 카테고리는 어때요?" 한 줄(09-29 미리보기 B안) — 순수 모듈.
 *
 * 쓸 수 있는 카테고리는 3D 그림이 있는 홈 카테고리 타일뿐이다(CategoryVariantB 의
 * categoryCode 와 같은 코드 · HOT_CATEGORY_ROOT_CODES 와 같은 순서). 새 요청 없이 이미
 * 가진 데이터로 고른다 — 아래 "○○ 추천 상품"(0건 폴백 상품)의 카테고리를 그 순서대로,
 * 모자라면 타일 기본 순서(= 홈·HOT 후보 순서).
 */

/** 3D 타일 — 코드 + 160px WebP(겹친 40px 그림용). 순서 = 전역 기본 순서 */
export const CATEGORY_3D_TILES = [
  { code: "20-01", image: "/icons/categories/home-smartphone-3d-v3-160.webp" },
  { code: "10-06-01", image: "/icons/categories/home-lightstick-3d-v2-160.webp" },
  { code: "10-01", image: "/icons/categories/home-camera-gimbal-3d-balanced-160.webp" },
  { code: "10-05-01", image: "/icons/categories/home-traditional-clothing-3d-v1-160.webp" },
  { code: "30-01", image: "/icons/categories/home-beauty-3d-balanced-160.webp" },
  { code: "40-01", image: "/icons/categories/home-stroller-3d-v2-160.webp" },
  { code: "50-01-03", image: "/icons/categories/home-bicycle-3d-balanced-160.webp" },
  { code: "50-01-02", image: "/icons/categories/home-motorcycle-3d-v1-160.webp" },
] as const;

export const POPULAR_CATEGORY_LIMIT = 3;

const TILE_CODES: readonly string[] = CATEGORY_3D_TILES.map((tile) => tile.code);

/** 상품 카테고리 코드 → 그 코드를 품는 타일 코드(자기 자신 또는 상위). 없으면 null */
export function tileCodeFor(code: string): string | null {
  return TILE_CODES.find((tile) => code === tile || code.startsWith(`${tile}-`)) ?? null;
}

export function tileImageFor(code: string): string | null {
  return CATEGORY_3D_TILES.find((tile) => tile.code === code)?.image ?? null;
}

/** 두 코드가 같은 갈래인가(같거나 한쪽이 다른 쪽의 하위) */
function overlaps(a: string, b: string): boolean {
  return a === b || a.startsWith(`${b}-`) || b.startsWith(`${a}-`);
}

/**
 * 추천 타일 코드(최대 `limit`).
 *  1. 폴백 상품 카테고리 — 목록 순서대로, 타일로 올려 중복 제거
 *  2. 타일 기본 순서로 채움
 * 사용자가 이미 고른 카테고리(0건을 낸 조건)와 겹치는 타일은 뺀다.
 */
export function suggestCategoryTiles(
  productCategoryCodes: ReadonlyArray<string | null | undefined>,
  excluded: readonly string[],
  limit = POPULAR_CATEGORY_LIMIT,
): string[] {
  const codes: string[] = [];
  const push = (tile: string | null) => {
    if (!tile || codes.includes(tile) || codes.length >= limit) return;
    if (excluded.some((code) => overlaps(tile, code))) return;
    codes.push(tile);
  };
  for (const code of productCategoryCodes) if (code) push(tileCodeFor(code));
  TILE_CODES.forEach(push);
  return codes;
}
